import { useEffect } from 'react';
import { Toaster } from 'react-hot-toast';
import ReactModal from 'react-modal';
import { AppRoutes } from '@/routes';
import { useAuthStore } from '@/store/authStore';
import { csrfService } from '@/services/csrfService';
import { TutorialProvider } from '@/context/TutorialContext';
import { secureLogger } from '@/utils/secureLogger';

// Set app element for react-modal
ReactModal.setAppElement('#root');

function App() {
  const { checkAuth } = useAuthStore();

  useEffect(() => {
    // Initialize auth and CSRF in background
    checkAuth().catch(secureLogger.error);
    csrfService.initialize().catch(secureLogger.error);
  }, [checkAuth]);

  return (
    <TutorialProvider>
      <AppRoutes />
      <Toaster position="top-right" />
    </TutorialProvider>
  );
}

export default App;
